import { render, staticRenderFns } from "./ManageServiceCost.vue?vue&type=template&id=a202d21a&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ManageServiceCost.vue?vue&type=style&index=0&id=a202d21a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a202d21a",
  null
  
)

export default component.exports